import React, { useState } from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";

import { getIcon } from "../../helpers/icons";
import Link from "../Link";
import Title from "../Title";
import AsyncGet from "../AsyncGet";

import style from "./style.module.css";

export default function Rating({ type = "article", id, rating = null, label = true }) {

    const userProfile = useSelector((state) => state.storage.data);
    const [star, setStar] = useState(rating === null ? 0 : rating);
    const [rate, setRate] = useState(0);

    return (
        <div className={style.stars}>
            <div className={style.starList}>
                {
                    <AsyncGet
                        url={`/account/rate/${id}`}
                        permissionText="Rate"
                        method="post"
                        paramsData={{
                            type: type,
                            rating: rate
                        }}
                        onFetch={({ data }) => {
                            if (get(data, "rating") !== "") {
                                setStar(get(data, "rating"))
                            }
                        }}
                        render={({ loadFromAPI }) => {
                            return (
                                <>
                                    {[...Array(5)].map((i, k) => {
                                        k = k + 1;
                                        return (
                                            <Link
                                                to={userProfile.id === undefined ? `/sign-in?redirect=${window.location.pathname}` : ``}
                                                onClick={userProfile.id !== undefined ? () => { setRate(k); loadFromAPI() } : () => {}} 
                                                className={userProfile.id !== undefined ? style.loginYes : style.loginNo } 
                                                key={`rating_${k}`}
                                            >
                                                <i className={`${getIcon("Star")} ${star >= k ? style.active : ''}`}></i>
                                            </Link>
                                        )
                                    })}
                                </>
                            )
                        }}
                    />
                }
            </div>
            {
                label === true && (
                    <Title tag="p">Rate</Title>
                )
            }
        </div>
    )
}